import { useEffect, useState } from "react";

export default function useFetch(url) {
  // load, error, data
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [gif, setGif] = useState(null);

  // fetch data
  useEffect(() => {
    async function fetchUrl() {
      try {
        setLoading(false);
        setError(false);
        // send request
        const res = await fetch(url);

        // convert data to json
        const { data } = await res.json();

        // update date
        setGif(data);
      } catch (err) {
        console.log(err);
        setError(true);
        setLoading(false);
      }
    }

    fetchUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loading,
    error,
    gif,
  };
}
